import { cn } from "@omni/utils/styles";
import { useEffect, useState } from "react";

import { Dropdown } from "@/components/General/Dropdown/dropdown.component";
import { Config } from "@/utils/config.utils";

export type AmountDropDownComponentProps = {
    value: number;
    isUpdatingCart: boolean;
    minimumOrderQuantity: number;
    roundingValue?: number;
    onQuantityChange: (newQuantity: number, oldQuantity: number) => void;
};

const AmountDropDownComponent = ({
    isUpdatingCart,
    value,
    minimumOrderQuantity,
    roundingValue,
    onQuantityChange
}: AmountDropDownComponentProps) => {
    const options = [];
    const [quantity, setQuantity] = useState(0);

    useEffect(() => {
        setQuantity(value);
    }, [value]);

    useEffect(() => {
        if (!isUpdatingCart && value !== quantity) {
            setQuantity(value);
        }
    }, [value, isUpdatingCart, quantity]);

    for (
        let i = minimumOrderQuantity;
        i < Config.general["maximum-order-quantity"];
        i += roundingValue ? roundingValue : 0
    ) {
        options.push(i);
    }

    const onOptionClick = (option: number) => {
        const oldQuantity = quantity;

        if (isUpdatingCart) {
            return;
        }

        setQuantity(option);
        onQuantityChange(option, oldQuantity);
    };

    return (
        <Dropdown
            placement={"bottom"}
            isLabel={false}
        >
            <Dropdown.Toggle
                className={cn(
                    "tw:bg-background! tw:text-black! tw:border tw:border-grey-input",
                    "tw:flex tw:w-38 tw:justify-between tw:items-center tw:indent-3",
                    "tw:md:w-33"
                )}
            >
                <Dropdown.Label>{quantity}</Dropdown.Label>
                <Dropdown.Caret />
            </Dropdown.Toggle>
            <Dropdown.Menu
                className={cn(
                    "tw:max-h-69 tw:min-w-38! tw:overflow-y-auto tw:md:min-w-33!"
                )}
            >
                {options.map((option) => (
                    <Dropdown.Item
                        key={option}
                        onClick={() => {
                            onOptionClick(option);
                        }}
                        label={option}
                    />
                ))}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export { AmountDropDownComponent };
